import { useEffect } from "react";
import { useSelector } from "react-redux";

const ThemeApplier = () => {
  const theme = useSelector((state) => state.theme.current);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return null;
};

export default ThemeApplier;
